import {connect} from 'react-redux';
import {
    ActionsRow,
    authActions,
    field,
    HorizontalLoader,
    InfiniteScroll,
    Loader,
    modal,
    PageContent,
    ScrollableCard,
    utils
} from "@mc/mc-legacy";
import {withRouter} from "react-router";
import * as opravneniActions from "../actions/opravneniActions";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as ciselnikActions from "../actions/ciselnikActions";
import {
    Alert,
    Button,
    ButtonDropdown,
    ButtonGroup,
    ButtonToolbar,
    CardBody,
    CardHeader,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Label,
    Row
} from "reactstrap";
import ObjednavkyListCountStats from "../components/ObjednavkyListCountStats";
import * as uzivatelActions from "../actions/uzivatelActions";
import ObjednavkaListPanel from "../components/ObjednavkaListPanel";
import {formatDate, getOrderTimeoutMinutes, redirectToOrderStepNumber} from "../utils/utils";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import Title from "../components/Title";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import {debounce} from 'lodash-es';
import NakladoveStrediskoField from "../forms/fields/NakladoveStrediskoField";
import RozpracovanaObjednavkaModal from "../components/RozpracovanaObjednavkaModal";
import './ObjednavkyPage.scss';
import * as React from "react";
import {Component} from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const {storeFromArea} = utils;

// Jak často aktualizovat seznam objednávek
const ORDERS_REFRESH_TIMEOUT = 60000;

/**
 * Stránka se seznamem objednávek.
 */
class ObjednavkyPage extends Component<WithTranslation> {

    constructor() {
        super();
        this.state = {
            pobockyDropdownOpen: false,
            selectedPobocka: undefined,
        }
    }

    componentDidMount() {
        this.fetchData();
        this.interval = setInterval(this.reloadObjednavky, ORDERS_REFRESH_TIMEOUT);
    }

    componentDidUpdate() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    fetchData = () => {
        const {spolecnostId, loggedInUser, pobockyList, objednavkyList} = this.props;
        const {selectedPobocka} = this.state ? this.state : null;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (spolecnostId.fetched && !spolecnostId.isFetching) {
            this.props.dispatch(objednavkaActions.fetchObjednavkyIfNeeded(spolecnostId.data));
            this.props.dispatch(ciselnikActions.fetchNakladovaStrediskaIfNeeded(spolecnostId.data));
            this.handleFilterSpolecnost(spolecnostId.data);
        }
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUser.data.id));
            if (loggedInUser.data.role === EnumRole.OPERATOR || loggedInUser.data.role === EnumRole.ADMIN) {
                this.props.dispatch(ciselnikActions.fetchPobockyOperatorIfNeeded());
            }
            this.props.dispatch(objednavkaActions.fetchObjednavkaLastStep(loggedInUser.data.id));
            this.props.dispatch(objednavkaActions.fetchObjednavkaLastFinishedStep(loggedInUser.data.id));
            this.props.dispatch(objednavkaActions.fetchCasRozpracovaniObjednavky(loggedInUser.data.id));
        }
        //filtr poboček...
        if (pobockyList.fetched && !pobockyList.isFetching) {
            // není vybrána žádná pobočka, ale ve filtru je z předchozího dotazu přesně jedna - nastavíme ji do comba, aby byla vidět
            if (!selectedPobocka && objednavkyList && objednavkyList.filter.pobockaIdList && objednavkyList.filter.pobockaIdList.length === 1) {
                const pobocka = pobockyList.rows.find(x => x.id === objednavkyList.filter.pobockaIdList[0]);
                if (pobocka) {
                    this.setState({selectedPobocka: pobocka});
                }
            }
            // není vybraná pobočka, ale je dostupná právě jedna => automaticky ji vybereme
            if (pobockyList.rows.length === 1 && !selectedPobocka) {
                this.handlePobockaChange(pobockyList.rows[0]);
            }
        }
    };

    reloadObjednavky = () => {
        const {spolecnostId} = this.props;
        this.props.dispatch(objednavkaActions.reloadObjednavky(spolecnostId.data));
    };

    handleResetFilter = () => {
        this.setState({selectedNakladoveStredisko: undefined});
        this.props.dispatch(objednavkaActions.filterObjednavky({fulltext: "", nakladoveStredisko: ""}));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({fulltext: "", nakladoveStredisko: ""}));
    };

    handleFulltextChange = (value) => {
        const {objednavkyList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            fulltext: value
        }));
    };

    handleFilterStav = (value) => {
        const {objednavkyList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            stav: value
        }));
    };

    handleFilterSpolecnost = (value) => {
        const {objednavkyList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            spolecnostId: value
        }));
    };

    // TODO berka duplicitní kód na CustomerHomePage - ideálně někam vytáhnout
    handleNovaObjednavka = () => {
        const {authInfo, loggedInUser, lastSavedStep, lastSavedFinishedStep, casRozpracovaniObjednavky, t} = this.props;

        if (!lastSavedStep.data && !lastSavedFinishedStep.data) { // nemáme rozpracovanou objednávku
            return redirectToOrderStepNumber(1, this.props);
        }
        // máme rozpracovanou objednávku - zkontrolujeme timeout
        const casRozpracovaniSeconds = casRozpracovaniObjednavky.data && Math.floor(casRozpracovaniObjednavky.data / 1000);
        const timeoutMinutes = getOrderTimeoutMinutes(authInfo);
        if (casRozpracovaniSeconds && timeoutMinutes) {
            const currentTimeSeconds = Math.floor(Date.now() / 1000);
            const timeoutSeconds = timeoutMinutes * 60;
            const remaining = (casRozpracovaniSeconds + timeoutSeconds) - currentTimeSeconds;
            if (remaining <= 0) {
                this.props.dispatch(objednavkaActions.clearRozpracovanaObjednavka(loggedInUser.data.id));
                return redirectToOrderStepNumber(1, this.props);
            }
        }
        // objednávka zatím nevypršela - necháme uživatele pokračovat
        this.props.dispatch(
            modal.ModalActions.show(
                RozpracovanaObjednavkaModal,
                {
                    onContinueOrder: () => {
                        this.props.dispatch(modal.ModalActions.hide());
                        const step = lastSavedFinishedStep.data ? lastSavedFinishedStep.data + 1 : lastSavedStep.data;
                        redirectToOrderStepNumber(step, this.props);
                    },
                    onNewOrder: () => {
                        this.props.dispatch(modal.ModalActions.hide());
                        this.props.dispatch(objednavkaActions.clearRozpracovanaObjednavka(loggedInUser.data.id));
                        redirectToOrderStepNumber(1, this.props);
                    },
                },
                t('order.unfinished'),
            )
        );
    };

    handlePobockaChange = (pobocka) => {
        const {objednavkyList} = this.props;
        this.setState({selectedPobocka: pobocka});
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            pobockaIdList: pobocka ? [pobocka.id] : null
        }));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            pobockaIdList: pobocka ? [pobocka.id] : null
        }));
    };

    handleDatumOdChange = (event) => {
        const {objednavkyList} = this.props;
        const datumOd = event.target.value;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            datumOd: datumOd
        }));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            datumOd: datumOd
        }));
    };

    handleDatumDoChange = (event) => {
        const {objednavkyList} = this.props;
        const datumDo = event.target.value;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            datumDo: datumDo
        }));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            datumDo: datumDo
        }));
    };

    updateNakladoveStredisko = () => {
        const naklStred = this.state.selectedNakladoveStredisko;
        const {objednavkyList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            nakladoveStredisko: naklStred
        }));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            nakladoveStredisko: naklStred
        }));
    };

    handleNakladoveStrediskoChange = (naklStred) => {
        if (naklStred && naklStred.target) naklStred = naklStred.target.value;
        this.setState({selectedNakladoveStredisko: naklStred});
        this.debouncedNakladoveStredisko();
    };

    debouncedNakladoveStredisko = debounce(this.updateNakladoveStredisko, 500);

    handleUzivatelChange = (uzivatel) => {
        const {objednavkyList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavky({
            ...objednavkyList.filter,
            uzivatel: uzivatel
        }));
        this.props.dispatch(objednavkaActions.filterObjednavkyCountStats({
            ...objednavkyList.filter,
            uzivatel: uzivatel
        }));
    };

    renderHeader = () => {
        const {objednavkyList, loggedInUser, pobockyList, nakladovaStrediskaList, t} = this.props;
        const {selectedPobocka, selectedNakladoveStredisko} = this.state;

        if (!loggedInUser.fetched || loggedInUser.isFetching || !nakladovaStrediskaList.fetched || nakladovaStrediskaList.isFetching) {
            return <Loader/>;
        }

        const userInfo = loggedInUser.data;
        const jsemUzivatel = userInfo.role === EnumRole.UZIVATEL;
        const jsemAdmin = userInfo.role === EnumRole.ADMIN;
        const jsemOperator = userInfo.role === EnumRole.OPERATOR;
        const jsemSpravceSpolecnosti = userInfo.role === EnumRole.SPRAVSPOL;

        const pobockyFetched = pobockyList.fetched && !pobockyList.isFetching;
        // Přepínač poboček uvidí pouze uživatel v roli ADMIN nebo OPERATOR a pouze pokud nemá nastavenou kontrolu IP adresy
        const muzeZvolitPobocku = (jsemAdmin || jsemOperator) && !userInfo.rgKontrolaIpAdresa && pobockyFetched;
        // Uživatelé uvidí jen základní filtr
        const rozsirenyFiltr = !jsemUzivatel;

        const {fulltext, datumOd, datumDo, nakladoveStredisko, uzivatel} = objednavkyList.filter;
        const filtrAktivni = (fulltext && fulltext.length > 0) || datumOd || datumDo || (nakladoveStredisko && nakladoveStredisko.length > 0) || uzivatel;
        let filterContent;
        if (filtrAktivni) {
            let aktivniFiltry = [];
            if (fulltext && fulltext.length > 0) aktivniFiltry.push("- fulltext: " + fulltext);
            if (datumOd) aktivniFiltry.push(t('order.date_from',{dateFrom: formatDate(datumOd)}));
            if (datumDo) aktivniFiltry.push(t('order.date_to',{dateFrom: formatDate(datumDo)}));
            if (nakladoveStredisko && nakladoveStredisko.length > 0) aktivniFiltry.push(t('order.order_name', {orderName: nakladoveStredisko}));
            if (uzivatel) aktivniFiltry.push(t('order.user_name', {username: uzivatel.zobrazJmeno}));
            let filterText = aktivniFiltry.map(a => <span>{a}<br/></span>);
            filterContent = <Alert color="info" isOpen toggle={this.handleResetFilter}>{t('search_filtered_result')}<br/>{filterText}</Alert>;
        }

        let pobockaSelectContent;
        if (muzeZvolitPobocku) {
            pobockaSelectContent = <span className="header-actions"> | {selectedPobocka && <span>{t('for_branch')}</span>} <ButtonDropdown className="transparent-dropdown" isOpen={this.state.pobockyDropdownOpen} toggle={() => this.setState({pobockyDropdownOpen: !this.state.pobockyDropdownOpen})}>
                    <DropdownToggle caret color="default">
                        {selectedPobocka ? selectedPobocka.nazevPobocka : t('choose_branch')}
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={this.handlePobockaChange.bind(this, null)}><i>{t('all_t')}</i></DropdownItem>
                        {pobockyList.rows.map(pobocka => <DropdownItem key={pobocka.id} onClick={this.handlePobockaChange.bind(this, pobocka)}>{pobocka.nazevPobocka}</DropdownItem>)}
                    </DropdownMenu>
                </ButtonDropdown>
            </span>
        }

        // Správce má k dispozici našeptávač, operátoři a admini jen obyčejný string field
        let nakladoveStrediskoFieldContent;
        if (jsemSpravceSpolecnosti) {
            nakladoveStrediskoFieldContent = <Col md={2} className={"inline-input"}>
                <Label className={"mr-3"}>{t('order.name')}</Label>
                <NakladoveStrediskoField
                    nakladovaStrediska={nakladovaStrediskaList.rows}
                    onChange={this.handleNakladoveStrediskoChange}
                    value={selectedNakladoveStredisko || ""}
                />
            </Col>;
        } else {
            nakladoveStrediskoFieldContent = <Col md={2} className={"inline-input"}>
                <Label className={"mr-3"}>{t('order.name')}</Label>
                <field.String onChange={this.handleNakladoveStrediskoChange} value={selectedNakladoveStredisko ? selectedNakladoveStredisko.nazevStredisko : ""} />
            </Col>;
        }

        return <div>
            <CardHeader>
                <ActionsRow actions={<ButtonToolbar>
                    <ButtonGroup>
                        <Button color="primary-inverse" className="mr-2" onClick={this.handleNovaObjednavka}>{t('order.new')}</Button>
                    </ButtonGroup>
                </ButtonToolbar>
                }>
                    <h2>{t('order.many')} {pobockaSelectContent}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody className={"border-bottom"}>
                <Row>
                    <Col md={3} className={"inline-input"}>
                        <field.Search value={objednavkyList.filter.fulltext} onChange={this.handleFulltextChange}
                                      placeholder={t('order.filter')}/>
                    </Col>
                    <Col md={3} className={"inline-input"}>
                        <Label className={"mr-3"}>Datum</Label>
                        <field.SimpleDate className={"mr-3"} placeholder={"Od"} onChange={this.handleDatumOdChange} value={datumOd} style={{maxWidth: "40%"}} />
                        <field.SimpleDate placeholder={"Do"} onChange={this.handleDatumDoChange} value={datumDo} style={{maxWidth: "40%"}} />
                    </Col>
                    {rozsirenyFiltr && nakladoveStrediskoFieldContent}
                    {rozsirenyFiltr && <Col md={2} className={"inline-input"}>
                        <Label className={"mr-3"}>Uživatel</Label>
                        <field.ApiObjectSuggest
                            label={t('user.one')}
                            dropdown={false}
                            removable={false}
                            itemValueAttrName="zobrazJmeno"
                            renderSuggestion={(item) => item ? item.zobrazJmeno : ""}
                            filterSuggestions={(value) => SubjektApi.getUzivatele(value, false)}
                            placeholder={t('search_for_user')}
                            onChange={this.handleUzivatelChange}
                            value={uzivatel}
                        />
                    </Col>}
                </Row>
            </CardBody>
            {filterContent && <CardBody>{filterContent}</CardBody>}
            <CardBody>
                <ObjednavkyListCountStats selectedStav={objednavkyList.filter.stav} onChange={this.handleFilterStav}/>
            </CardBody>
        </div>
    };

    render() {
        const {loggedInUser, objednavkyList, t} = this.props;

        if (!loggedInUser.fetched || !objednavkyList.fetched) {
            return <Loader/>;
        }

        return <Title title={t('order.list')}>
            <PageContent fullWidth className="objednavky-page">
                <ScrollableCard className="inverse" header={this.renderHeader()}>
                    <InfiniteScroll bordered loadMore={() => this.props.dispatch(objednavkaActions.loadObjednavkyMore())}
                                    hasMore={objednavkyList.hasMore}>
                        {objednavkyList.isFetching && <HorizontalLoader hover/>}
                        {objednavkyList.rows.map(item => {
                            const deleted = objednavkyList.deletedIds[item.id];
                            return <CardBody key={item.id} className={deleted ? "deleted" : null}>
                                <ObjednavkaListPanel objednavka={item}/>
                            </CardBody>
                        })}
                    </InfiniteScroll>
                </ScrollableCard>
            </PageContent>
        </Title>
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        spolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        objednavkyList: storeFromArea(state, objednavkaActions.OBJEDNAVKY_LIST_AREA),
        pobockyList: storeFromArea(state, ciselnikActions.POBOCKY_OPERATOR_LIST_AREA),
        nakladovaStrediskaList: utils.storeFromArea(state, ciselnikActions.NAKLADOVA_STREDISKA_LIST_AREA),
        lastSavedStep: utils.storeFromArea(state, objednavkaActions.LAST_SAVED_STEP_AREA),
        lastSavedFinishedStep: utils.storeFromArea(state, objednavkaActions.LAST_SAVED_FINISHED_STEP_AREA),
        casRozpracovaniObjednavky: utils.storeFromArea(state, objednavkaActions.CAS_ROZPRACOVANI_DETAIL_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ObjednavkyPage)));

